import { createSelector } from '@ngrx/store';
import { some } from '@sapphire/result';

import { getBuyerSettings } from '../../utils/buyer-settings.helper';
import { getUserType } from '../../utils/user-type.helper';

import { authFeature } from '../reducer/auth.reducer';

const {
  selectLoading,
  selectError,
  selectUser,
  selectAllBuyerSettings,
  selectCompanySettings,
  selectFailedLoginAttempts,
} = authFeature;

const selectIsAuthenticated = createSelector(selectUser, (user) =>
  user.isSome(),
);

const selectUserType = createSelector(selectUser, (user) =>
  user.mapInto((_user) => some(getUserType(_user))).unwrapOr('none'),
);

const selectBuyerSettings = createSelector(
  selectUser,
  selectAllBuyerSettings,
  (user, allSettings) =>
    user
      .mapInto(({ companyId }) => {
        const buyerSettings = getBuyerSettings(allSettings, companyId);
        return some(buyerSettings);
      })
      .unwrapOr({}),
);

export {
  selectLoading,
  selectError,
  selectUser,
  selectIsAuthenticated,
  selectUserType,
  selectBuyerSettings,
  selectAllBuyerSettings,
  selectCompanySettings,
  selectFailedLoginAttempts,
};
